import { surveyAxiosClient } from '@kinderlabs-pos/apis/axios';

export const postElectronicReceiptAsync =
  (rootUrl: string) =>
  async ({
    orderId,
    phoneNumber,
  }: {
    orderId: string;
    phoneNumber: string;
  }) =>
    (
      await surveyAxiosClient.post<void>(
        `${rootUrl}/api/v2/receipts/${orderId}/resend`,
        { phone: phoneNumber }
      )
    ).data;
